module.exports = __webpack_public_path__ + "img/loan-status9.d731fe3d.png";